import SiteImageField from './SiteImageField';
import { uploadReceiptTicketImage } from '../lib/api';

/** Imagen superior del ticket de venta (config tienda Pizas). */
export default function ReceiptTicketImageField({ url, onChange }) {
  return (
    <SiteImageField
      label="Imagen superior del ticket"
      url={url}
      onChange={onChange}
      previewVariant="logo"
      uploadFile={uploadReceiptTicketImage}
    />
  );
}
